import React from 'react';
import { prismicText } from 'helpers';
import { PrismicFluidImage } from 'components/Prismic';
import { VisualImages } from './types';

const FullScreen: React.StatelessComponent<VisualImages> = ({ images }) => {
    if (!images[0]) {
        return null;
    }
    return (
        <div className="Visual-fullScreen">
            <PrismicFluidImage
                image={images[0].visual_imageSharp}
                fallback={images[0].visual_image}
                alt={prismicText(images[0].visual_image_atl)}
            />
        </div>
    );
};
export default FullScreen;
